import { Redirect, useLocation } from 'react-router-dom'
import { logoutUser } from '../../actions/user'
import { LoginHeroWidget, Fade } from '../../components/common'
import useCatapultAuth from '../../hooks/useCatapultAuth'
import { NAV_LINKS } from '../../constants/NavConstants'

const mapStateToProps = state => ({})

const LoginPage = ({ logoutUser }) => {
  const { search, pathname, from } = useLocation()
  const { isAuthed } = useCatapultAuth()
  const previous = from && from !== '/' ? from : pathname

  useEffect(() => {
    logoutUser()
  }, [])

  return (
    <Fade>
      <div>
        {isAuthed ? (
          <Redirect to={{ pathname: NAV_LINKS.dashboard, from: previous, search }} />
        ) : (
          <div>
            <LoginHeroWidget />
          </div>
        )}
      </div>
    </Fade>
  )
}

export default connect(mapStateToProps, { logoutUser })(LoginPage)
